import { useObserverCallback } from "./useObserverCallback";
import { timer } from "rxjs";
import { DependencyList } from "react";

export const useOnTimeoutCallback = (
  timeMs: number,
  callback: () => void,
  deps: DependencyList = []
) => {
  useObserverCallback<number>(timer(timeMs), callback, deps);
};
